import { render, staticRenderFns } from "./GoodsInitial.vue?vue&type=template&id=2a326cc5&scoped=true&"
import script from "./GoodsInitial.vue?vue&type=script&lang=js&"
export * from "./GoodsInitial.vue?vue&type=script&lang=js&"
import style0 from "./GoodsInitial.vue?vue&type=style&index=0&id=2a326cc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a326cc5",
  null
  
)

export default component.exports